"use strict";
exports.__esModule = true;
exports.Modal = void 0;
var Modal_1 = require("./Modal");
var ModalClose_1 = require("./ModalClose");
var ModalContainer_1 = require("./ModalContainer");
var ModalContent_1 = require("./ModalContent");
var ModalOpen_1 = require("./ModalOpen");
var Modal = Object.assign(Modal_1.Modal, {
    Container: ModalContainer_1.ModalContainer,
    Close: ModalClose_1.ModalClose,
    Content: ModalContent_1.ModalContent,
    Open: ModalOpen_1.ModalOpen
});
exports.Modal = Modal;
//# sourceMappingURL=index.js.map